module.exports = __webpack_public_path__ + "img/image102.03f3db93.jpg";